<div id="carouselEmpreendimentos" class="carousel slide d-block d-md-none" data-bs-ride="carousel"
  data-bs-interval="3000">
  <div class="carousel-inner">
    <div *ngFor="let empreendimento of empreendimentos; let i = index" class="carousel-item"
      [ngClass]="{'active': i === 0}" (click)="abreCondominio(empreendimento.code)">
      <div class="card-empreendimento">
        <img [src]="empreendimento.foto" alt="Unidade Cancian" class="card-image-empreendimento" />
        <div class="card-footer">
          <h3>{{ empreendimento.nome }}</h3>
          <p>{{ empreendimento.endereco }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Controles de Navegação -->
  <button class="carousel-control-prev" type="button" [attr.data-bs-target]="'#carouselEmpreendimentos'"
    data-bs-slide="prev" style="z-index: 100;">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>

  <button class="carousel-control-next" type="button" [attr.data-bs-target]="'#carouselEmpreendimentos'"
    data-bs-slide="next" style="z-index: 100;">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>

</div>


<!-- Exibição Normal para Desktop -->
<div class="card-container-cancian d-none d-md-flex">
  <div *ngFor="let empreendimento of empreendimentos" class="card-empreendimento"
    (click)="abreCondominio(empreendimento.code)">
    <img [src]="empreendimento.foto" alt="Unidade Cancian" class="card-image-empreendimento" />
    <div class="card-actions">
      <!-- <a (click)="openTelefone(unidade.nome, unidade.telefone)" title="Ligar">
        <mat-icon class="icon-vermelho">phone</mat-icon>
      </a>
      <a [href]="unidade.linkMapa" target="_blank" title="Ver no mapa">
        <mat-icon class="icon-vermelho">location_on</mat-icon>
      </a> -->
    </div>
    <div class="card-footer">
      <h3>{{ empreendimento.nome }}</h3>
      <p>{{ empreendimento.endereco }}</p>
    </div>
  </div>
</div>

<!-- <div class="content-2">
  <div class="div-small-content" style="border-bottom: none !important;">
    <div class="btn-small-content-condominios" (click)="abreCondominio('392')">
      <div class="btn-small-content-3">
        <img src="../../assets/empreendimentos/livty.jpeg" alt="">
      </div>
    </div>
    <div class="btn-small-content-condominios" (click)="abreCondominio('1936')">
      <div class="btn-small-content-3">
        <img src="../../assets/empreendimentos/uniqo.png" alt="">
      </div>
    </div>
    <div class="btn-small-content-condominios" (click)="abreCondominio('247')">
      <div class="btn-small-content-3" style="background: #f7f7f7;">
        <img src="../../assets/empreendimentos/vitta.png" alt="">
      </div>
    </div>
    <div class="btn-small-content-condominios" (click)="abreCondominio('2126')">
      <div class="btn-small-content-3" style="background: #025158;">
        <img src="../../assets/empreendimentos/franciscano.jpg" alt="">
      </div>
    </div>
  </div>
</div> -->